import { render, staticRenderFns } from "./SolCompras.vue?vue&type=template&id=74eb78c6&scoped=true&"
import script from "./SolCompras.vue?vue&type=script&lang=js&"
export * from "./SolCompras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eb78c6",
  null
  
)

export default component.exports